import { HTTPURL } from "@bracket/types";

export declare type LogoVariant = "stroked" | "normal";

export declare type GetLogoVariantProps = {
	url: HTTPURL;
	variant: LogoVariant;
};

export const getLogoVariant = ({ url, variant, }: GetLogoVariantProps) => {
	if(!url ||variant === "normal") return url;
	const hostpart = url.split("/").slice(0, -1).join("/");
	const filename = url.split("/").pop();
	if(filename) {
		const name = filename.split(".").slice(0, -1).join(".");
		const extension = filename.split(".").pop();
		const newUrl = `${hostpart}/${name}-${variant}.${extension}`;
		return newUrl;
	}
	throw new Error("Invalid URL");
};
